import React from 'react';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import { flattenToAppURL } from '@plone/volto/helpers';

const resolveLink = (val) => {
  if (!val) return '';
  if (typeof val === 'string') return val;
  if (Array.isArray(val)) return resolveLink(val[0]);
  if (val['@id']) return flattenToAppURL(val['@id']);
  if (val.url) return val.url;
  return '';
};

const isExternalHref = (href = '') =>
  /^https?:\/\//i.test(href) ||
  href.startsWith('mailto:') ||
  href.startsWith('tel:');

const CTASectionView = ({ data = {}, isEditMode = false }) => {
  const link = resolveLink(data.link);
  const title = data.title || 'CTA Titel';
  const description = data.description || '';
  const buttonLabel = data.button_label || 'JETZT LESEN';
  const bg = data.background_color || 'gray';
  const external = isExternalHref(link);
  const isFullWidth = !!data.full_width;

  const themeClass = `fcmh-cta--${bg}`;
  const widthClass = isFullWidth ? 'fcmh-cta--full-width' : '';
  const headingId = `cta-heading-${data?.block || 'default'}`;

  return (
    <section
      className={`fcmh-cta ${themeClass} ${widthClass}`}
      aria-labelledby={headingId}
    >
      <div className="fcmh-cta__inner ui container">
        <div className="fcmh-cta__left">
          <h2 id={headingId} className="fcmh-cta__title">
            {title}
          </h2>
        </div>

        <div className="fcmh-cta__right">
          {description && (
            <p className="fcmh-cta__description">{description}</p>
          )}

          {link && (
            <UniversalLink
              href={link}
              className="fcmh-cta__button"
              target={external ? '_blank' : undefined}
              rel={external ? 'noopener noreferrer' : undefined}
              disabled={isEditMode}
            >
              <span>{buttonLabel}</span>
            </UniversalLink>
          )}
        </div>
      </div>
    </section>
  );
};

export default CTASectionView;
